module.exports = __webpack_public_path__ + "static/media/homePageWeb.f1b55d87.mp4";